import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const RelatedServices = [
  { title: 'Commercial Closings', path: '/services/commercial-closings' },
  { title: 'Title Insurance', path: '/services/title-insurance' },
  { title: 'Title Searches', path: '/services/title-searches' },
  { title: 'Deed Preparation', path: '/services/deed-preparation' },
];

const ExchangesPage = () => {
  return (
    <>
      <head>
        <title>1031 Exchanges Bucks County PA | Black Dog Settlement</title>
        <meta name="description" content="1031 tax-deferred exchange services for investment property owners in Bucks, Montgomery, Chester, and Delaware County, PA. Coordinate with qualified intermediaries. Call 215-499-0796." />
        <meta name="keywords" content="1031 exchange Bucks County PA, tax deferred exchange Newtown PA, like-kind exchange Montgomery County, investment property exchange Chester County Pennsylvania" />
        <link rel="canonical" href="https://www.blackdogsettlement.com/services/1031-exchanges" />
        <meta name="geo.region" content="US-PA" />
        <meta name="geo.placename" content="Newtown, Pennsylvania" />
        <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700;800;900&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
      </head>
      <div style={{ fontFamily: "'Inter', sans-serif" }}>
        <Navbar />
        <section className="bg-[#0f0f0f] pt-36 pb-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="flex items-center gap-2 text-stone-500 text-xs mb-8">
              <Link to="/" className="hover:text-[#c9a84c] cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <Link to="/services" className="hover:text-[#c9a84c] cursor-pointer">Services</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white/40">1031 Exchanges</span>
            </div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">Service</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-white leading-tight mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              1031<br /><span className="text-[#c9a84c]">Exchanges</span>
            </h1>
            <p className="text-white/40 text-base leading-relaxed max-w-xl">
              Defer capital gains taxes by exchanging investment properties under IRS Section 1031 with experienced coordination and strict compliance.
            </p>
          </div>
        </section>
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col lg:flex-row gap-16">
            <div className="w-full lg:w-[65%]">
              <div className="mb-10 overflow-hidden h-[380px]">
                <img
                  src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1000&h=500&fit=crop&q=80"
                  alt="1031 exchange services in Bucks County Pennsylvania"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h2 className="text-3xl font-black text-[#0f0f0f] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Maximize Your Investment with a 1031 Exchange</h2>
              <div className="space-y-4 text-stone-500 text-sm leading-relaxed mb-10">
                <p>A 1031 exchange — named after Section 1031 of the Internal Revenue Code — allows real estate investors to defer capital gains taxes when selling an investment property, as long as the proceeds are reinvested into a like-kind property within strict IRS timelines.</p>
                <p>Black Dog Settlement coordinates 1031 exchanges for investment property owners throughout Bucks, Montgomery, Chester, and Delaware County, PA. We work closely with qualified intermediaries (QIs) and your tax advisors to ensure full IRS compliance and a smooth exchange process.</p>
                <p>The rules are strict: you have 45 days to identify replacement properties and 180 days to close. Missing these deadlines can disqualify the exchange and trigger a large tax bill. Our experienced team keeps your transaction on track.</p>
              </div>
              <h3 className="text-xl font-black text-[#0f0f0f] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Exchange Types We Handle</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                {['Simultaneous exchanges', 'Delayed (Starker) exchanges', 'Reverse exchanges', 'Improvement (construction) exchanges', 'Multi-property exchanges', 'Coordination with QI', 'Strict 45/180-day timeline management', 'Like-kind property guidance', 'Residential to commercial exchanges', 'Commercial to residential exchanges'].map((item) => (
                  <div key={item} className="flex items-center gap-3 text-sm text-stone-600 border border-stone-100 px-4 py-3">
                    <div className="w-4 h-4 flex items-center justify-center shrink-0"><i className="ri-check-line text-[#c9a84c]"></i></div>
                    {item}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full lg:w-[35%] space-y-6">
              <div className="bg-[#0f0f0f] p-8">
                <h3 className="text-white text-xl font-black mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Start Your Exchange</h3>
                <p className="text-white/40 text-sm mb-6">Time is critical in a 1031 exchange. Contact us today to get started.</p>
                <a href="tel:2154990796" className="flex items-center justify-center gap-2 w-full bg-[#c9a84c] hover:bg-[#b8963e] text-[#0f0f0f] font-bold py-3.5 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-colors mb-3">
                  <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line"></i></div>
                  Call 215-499-0796
                </a>
                <Link to="/contact" className="flex items-center justify-center w-full border border-white/20 hover:border-white/50 text-white font-bold py-3.5 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-colors">
                  Send a Message
                </Link>
              </div>
              <div className="border border-stone-100 p-6">
                <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-stone-400 mb-4">Related Services</h4>
                <div className="space-y-2">
                  {RelatedServices.map((s) => (
                    <Link key={s.path} to={s.path} className="flex items-center justify-between py-2.5 border-b border-stone-100 last:border-0 text-sm text-[#0f0f0f] hover:text-[#c9a84c] transition-colors cursor-pointer group">
                      {s.title}
                      <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-xs text-stone-300 group-hover:text-[#c9a84c] transition-colors"></i></div>
                    </Link>
                  ))}
                </div>
              </div>
              <div className="bg-[#f7f5f0] p-6 space-y-3">
                <p className="text-xs font-bold tracking-[0.2em] uppercase text-stone-400 mb-4">Contact Info</p>
                <div className="flex items-center gap-3 text-sm text-stone-500"><div className="w-4 h-4 flex items-center justify-center shrink-0"><i className="ri-map-pin-2-line text-[#c9a84c]"></i></div>842 Durham Rd, Newtown, PA 18940</div>
                <div className="flex items-center gap-3 text-sm text-stone-500"><div className="w-4 h-4 flex items-center justify-center shrink-0"><i className="ri-time-line text-[#c9a84c]"></i></div>Mon–Fri: 9AM–5PM</div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default ExchangesPage;
